import { jsxs as a, Fragment as q, jsx as t } from "react/jsx-runtime";
import w from "../LeadForm/LeadForm.js";
import m from "@material-ui/core/Box";
import M from "@material-ui/core/Button";
import "@material-ui/core/Card";
import "@material-ui/core/CardActionArea";
import "@material-ui/core/CardActions";
import "@material-ui/core/CardContent";
import "@material-ui/core/CardMedia";
import "@material-ui/core/Checkbox";
import "@material-ui/core/Chip";
import "@material-ui/core/Container";
import v from "@material-ui/core/Dialog";
import x from "@material-ui/core/DialogActions";
import R from "@material-ui/core/DialogContent";
import "@material-ui/core/DialogTitle";
import "@material-ui/core/Divider";
import "@material-ui/core/ExpansionPanel";
import "@material-ui/core/ExpansionPanelDetails";
import "@material-ui/core/ExpansionPanelSummary";
import "@material-ui/core/FormControlLabel";
import "@material-ui/core/Grid";
import k from "@material-ui/core/IconButton";
import "@material-ui/core/InputLabel";
import "@material-ui/core/Link";
import "@material-ui/core/ListItemText";
import "@material-ui/core/MenuItem";
import "@material-ui/core/Paper";
import "@material-ui/core/ScopedCssBaseline";
import "@material-ui/core/Select";
import "@material-ui/core/styles/createStyles";
import "@material-ui/core/styles/makeStyles";
import "@material-ui/core/styles/useTheme";
import "@material-ui/core/styles/withStyles";
import "@material-ui/core/styles/withTheme";
import "@material-ui/core/Tooltip";
import f from "@material-ui/core/Typography";
import "@material-ui/core/useMediaQuery";
import "@material-ui/core/withWidth";
import "@material-ui/icons/Bathtub";
import "@material-ui/icons/CalendarToday";
import "@material-ui/icons/CheckCircle";
import F from "@material-ui/icons/Close";
import "@material-ui/icons/ExpandMore";
import "@material-ui/icons/Hotel";
import "@material-ui/icons/KeyboardArrowDown";
import "@material-ui/icons/Pets";
import "@material-ui/icons/Schedule";
import "@material-ui/icons/Search";
import "@material-ui/lab/Alert";
import { phoneValidator as j, normalizePhoneNumber as T } from "@propify-tenant-client/common";
import { getUnitShowingLink as B } from "../../utils/utils.js";
import { RegisterModal as D, LoginModal as A } from "@propify-tenant-client/account";
import { LeadService as P, LeadStatus as V, isSDK as z, handleError as E } from "@propify-tenant-client/services";
import { Formik as U, Form as G } from "formik";
import { useState as s } from "react";
import { useNavigate as K } from "react-router";
import * as r from "yup";
const W = r.object().shape({
  firstName: r.string().trim().required("Required"),
  lastName: r.string().trim().required("Required"),
  phone: r.string().trim().required("Required").test(
    "is-number",
    "Invalid Phone number",
    (o, l) => j(o, l.parent.countryCode)
  ),
  email: r.string().trim().required("Required").email("Invalid email"),
  message: r.string().nullable()
}), Qt = ({
  onClose: o,
  open: l,
  unit: i,
  onLoginSubmit: y,
  onRegisterSubmit: b
}) => {
  const [L, g] = s(!1), [S, p] = s(!1), [N, d] = s(!1), [u, C] = s(), I = K(), c = B(i);
  return /* @__PURE__ */ a(q, { children: [
    /* @__PURE__ */ t(
      U,
      {
        enableReinitialize: !0,
        validationSchema: W,
        initialValues: {
          firstName: "",
          lastName: "",
          phone: "",
          email: "",
          message: ""
        },
        onSubmit: (e, h) => {
          g(!0), P.create({
            source: "publicClient",
            status: V.ACTIVE,
            firstName: e.firstName,
            lastName: e.lastName,
            phone: T(e.phone),
            email: e.email,
            message: e.message || void 0,
            propertyId: i.property.id,
            floorplanId: i.floorplanId,
            unitId: i.id
          }).then((n) => {
            if (h.resetForm(), C(n), !z()) {
              I(c);
              return;
            }
            n.hasLogin ? d(!0) : p(!0);
          }).catch((n) => {
            E(n, { toastFallbackMessage: "An error occurred, please try again" });
          }).finally(() => {
            g(!1), h.setSubmitting(!1);
          });
        },
        children: (e) => /* @__PURE__ */ t(G, { children: /* @__PURE__ */ a(
          v,
          {
            open: l,
            onClose: () => {
              o();
            },
            maxWidth: "md",
            children: [
              /* @__PURE__ */ a(R, { children: [
                /* @__PURE__ */ a(
                  m,
                  {
                    style: { display: "flex", justifyContent: "space-between", alignItems: "center" },
                    children: [
                      /* @__PURE__ */ t(f, { variant: "h6", children: "Let's go touring!" }),
                      /* @__PURE__ */ t(k, { onClick: o, children: /* @__PURE__ */ t(F, {}) })
                    ]
                  }
                ),
                /* @__PURE__ */ t(m, { mt: 2, children: /* @__PURE__ */ t(f, { variant: "caption", style: { marginTop: 17 }, children: "Complete the form below and one of our professional leasing agents will contact you to schedule a self-showing of the property." }) }),
                /* @__PURE__ */ t(m, { mt: 2, children: /* @__PURE__ */ t(
                  w,
                  {
                    formProps: e,
                    noMargin: !0,
                    layout: { firstName: 6, lastName: 6, phone: 6, email: 6, message: 12 }
                  }
                ) }),
                /* @__PURE__ */ t(m, { mt: 2, children: /* @__PURE__ */ t(f, { variant: "caption", children: "By registering, you agree to Terms of Use and Privacy Policy and consent to be contacted at this phone number by text message, and/or by autodialer for any purpose, including marketing, by the property and anyone acting on their behalf. Consent not required to purchase or rent." }) })
              ] }),
              /* @__PURE__ */ t(x, { style: { justifyContent: "flex-end" }, children: /* @__PURE__ */ t(
                M,
                {
                  variant: "contained",
                  color: "primary",
                  onClick: e.submitForm,
                  disabled: L,
                  children: "Submit"
                }
              ) })
            ]
          }
        ) })
      }
    ),
    /* @__PURE__ */ t(
      D,
      {
        redirectLink: c,
        open: S,
        lead: u,
        onClose: () => {
          p(!1), o();
        },
        onSignIn: () => {
          p(!1), d(!0);
        },
        onRegisterSubmit: b
      }
    ),
    /* @__PURE__ */ t(
      A,
      {
        redirectLink: c,
        open: N,
        lead: u,
        onClose: () => {
          d(!1), o();
        },
        onLoginSubmit: y
      }
    )
  ] });
};
export {
  Qt as default
};
//# sourceMappingURL=LetsGoTouringModal.js.map
